import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadFlartListStatus: 'idle',
    loadFlartListError: undefined as any,
    loadFlartListLastArgs: undefined as any,
    loadFlartStatus: 'idle',
    loadFlartError: undefined as any,
    saveFlartStatus: 'idle',
    saveFlartError: undefined as any,
    deleteFlartStatus: 'idle',
    deleteFlartError: undefined as any,

    flartList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadFlartList = createAsyncThunk('flartSlice/loadFlartList', async ({ globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flartSlice.loadFlartListLastArgs
    if (_.isEqual(lastArgs, { globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/flart/?action=gte${globalFilters?.objectFilter !== undefined && globalFilters?.objectFilter !== null && globalFilters?.objectFilter !== '' ? `&MIN_OBJNR=${globalFilters.objectFilter}&MAX_OBJNR=${globalFilters.objectFilter}` : ''}`, globalFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlartListStatus } = getState().flartSlice
        return loadFlartListStatus !== 'pending'
    }
})

export const loadFlart = createAsyncThunk('flartSlice/loadFlart', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadFlartStatus } = getState().flartSlice
        return loadFlartStatus !== 'pending'
    }
})

export const saveFlart = createAsyncThunk('flartSlice/saveFlart', async ({ flart }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flart?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flart/${ flart?.HDR_ID }/`,
            prepareData(flart),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flart/`,
            prepareData(flart),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveFlartStatus } = getState().flartSlice
        return saveFlartStatus !== 'pending'
    }
})

export const deleteFlart = createAsyncThunk('flartSlice/deleteFlart', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteFlartStatus } = getState().flartSlice
        return deleteFlartStatus !== 'pending'
    }
})

const FlartSlice = createSlice({
    name: 'flartSlice',
    initialState,
    reducers: {
        resetloadFlartListError: (state) => {
            state.loadFlartListError = undefined
        },
        resetloadFlart: (state) => {
            state.formItem = undefined
            state.loadFlartError = undefined
        },
        resetloadFlartError: (state) => {
            state.loadFlartError = undefined
        },
        resetsaveFlart: (state) => {
            state.formItem = undefined
            state.saveFlartError = undefined
        },
        resetsaveFlartError: (state) => {
            state.saveFlartError = undefined
        },
        resetdeleteFlartError: (state) => {
            state.deleteFlartError = undefined
        },
        removeFromFlartListById: (state, action) => {
            state.flartList = state.flartList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlartListByIds: (state, action) => {
            state.flartList = state.flartList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flartList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadFlartListStatus = 'preloaded'
            state.loadFlartListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flartList = []
            state.loadFlartListStatus = 'idle'
            state.loadFlartListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadFlartList.pending, (state) => {
            state.loadFlartListStatus = 'pending'
            state.loadFlartListError = undefined
        })
        builder.addCase(loadFlartList.fulfilled, (state, action) => {
            state.loadFlartListStatus = 'idle'

            if (!action.payload) { return }

            state.loadFlartListLastArgs = action.payload.args

            {
                state.flartList = action.payload.data

            }
        })
        builder.addCase(loadFlartList.rejected, (state, action) => {
            state.loadFlartListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlartListError = action.error.message
            } else {
                state.loadFlartListError = action.payload
            }
        })

        builder.addCase(loadFlart.pending, (state) => {
            state.loadFlartStatus = 'pending'
            state.loadFlartError = undefined
        })
        builder.addCase(loadFlart.fulfilled, (state, action) => {
            state.loadFlartStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flartList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flartList.push(newItem) }
                else { state.flartList[i] = { ...state.flartList[i], ...newItem } }
            }
        })
        builder.addCase(loadFlart.rejected, (state, action) => {
            state.loadFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadFlartError = action.error.message
            } else {
                state.loadFlartError = action.payload
            }
        })

        builder.addCase(saveFlart.pending, (state) => {
            state.saveFlartStatus = 'pending'
            state.saveFlartError = undefined
        })
        builder.addCase(saveFlart.fulfilled, (state, action) => {
            state.saveFlartStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flartList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flartList.push(newItem) }
                else { state.flartList[i] = { ...state.flartList[i], ...newItem } }
            }
        })
        builder.addCase(saveFlart.rejected, (state, action) => {
            state.saveFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveFlartError = action.error.message
            } else {
                state.saveFlartError = action.payload
            }
        })

        builder.addCase(deleteFlart.pending, (state) => {
            state.deleteFlartStatus = 'pending'
            state.deleteFlartError = undefined
        })
        builder.addCase(deleteFlart.fulfilled, (state, action) => {
            state.deleteFlartStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flartList = state.flartList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flartList = state.flartList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteFlart.rejected, (state, action) => {
            state.deleteFlartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteFlartError = action.error.message
            } else {
                state.deleteFlartError = action.payload
            }
        })

    }
})

export const {
    resetloadFlartListError,
    resetloadFlart,
    resetloadFlartError,
    resetsaveFlart,
    resetsaveFlartError,
    resetdeleteFlartError,
    removeFromFlartListById,
    removeFromFlartListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlartSlice.actions
export default FlartSlice.reducer
